import { getOpenId } from '@/api/wechat'
const state = {
  openid: ''
}

const mutations = {
  SET_OPENID: (state, openid) => {
    state.openid = openid
  }
}

const actions = {
  getOpenid({ commit }, params) {
    return new Promise((resolve, reject) => {
      getOpenId(params).then(res => {
        if (res.code === 200) {
          commit('SET_OPENID', res.data.openid)
          resolve(res.data.openid)
        }
      }).catch(error => {
        reject(error)
      })
    })
  }

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

